import * as React from 'react';

export interface ModalContextProps {
    onClose?: () => void;
    showClose?: boolean;
}
export const ModalContext = React.createContext<ModalContextProps | null>(null);

export const useModalContext = (): ModalContextProps => {
    const context = React.useContext(ModalContext);

    if (!context) {
        throw new Error('useModalContext must be used with ModalContextProvider');
    }
    return context;
};
